import { 
  sceneDescriptions, 
  compositions, 
  cameraMovements, 
  visualStyles, 
  lightingStyles, 
  environments, 
  audioDescriptions, 
  dialogues, 
  colorPalettes 
} from '../data/presets';

const getRandomItem = (array) => {
  return array[Math.floor(Math.random() * array.length)];
};

export const randomizeAll = () => {
  return {
    sceneDescription: getRandomItem(sceneDescriptions),
    composition: getRandomItem(compositions),
    cameraMovement: getRandomItem(cameraMovements),
    visualStyle: getRandomItem(visualStyles),
    lighting: getRandomItem(lightingStyles),
    environment: getRandomItem(environments),
    audio: getRandomItem(audioDescriptions),
    dialogue: getRandomItem(dialogues),
    selectedColorPalette: Math.random() > 0.3 ? getRandomItem(colorPalettes) : null,
    customComposition: '',
    customCameraMovement: '',
    customVisualStyle: '',
    customLighting: '',
    customEnvironment: '',
    customAudio: ''
  };
};

export const randomizeField = (field) => {
  switch (field) {
    case 'scene':
      return {
        sceneDescription: getRandomItem(sceneDescriptions),
        composition: getRandomItem(compositions),
        cameraMovement: getRandomItem(cameraMovements),
        customCameraMovement: ''
      };
    case 'background':
      return {
        environment: getRandomItem(environments),
        lighting: getRandomItem(lightingStyles),
        selectedColorPalette: Math.random() > 0.5 ? getRandomItem(colorPalettes) : null,
        customEnvironment: '',
        customLighting: ''
      };
    case 'dialogue':
      return {
        dialogue: getRandomItem(dialogues),
        audio: getRandomItem(audioDescriptions),
        customAudio: ''
      };
    default:
      return {};
  }
};